import { defineAsyncComponent } from 'vue';

const Border = defineAsyncComponent(() => import('./Border'));
const ConfirmLosingChangesModal = defineAsyncComponent(() => import('./ConfirmLosingChangesModal'));
const DatePicker = defineAsyncComponent(() => import('./DatePicker'));
const DateRangePicker = defineAsyncComponent(() => import('./DateRangePicker'));
const DaypartEditor = defineAsyncComponent(() => import('./daypartEditor/DaypartEditor'));
const DaypartViewer = defineAsyncComponent(() => import('./DaypartViewer'));
const DemographicSelector = defineAsyncComponent(() => import('./DemographicSelector'));
const DropDown = defineAsyncComponent(() => import('./dropdown/DropDown'));
const DropDownGroup = defineAsyncComponent(() => import('./dropdown/DropDownGroup'));
const DropDownSelectableOptionGroup = defineAsyncComponent(() => import('./dropdown/DropDownSelectableOptionGroup'));
const EditableInput = defineAsyncComponent(() => import('./EditableInput'));
const EntityActions = defineAsyncComponent(() => import('./EntityActions'));
const FormattedInput = defineAsyncComponent(() => import('./FormattedInput'));
const FormLabel = defineAsyncComponent(() => import('./FormLabel'));
const FormSection = defineAsyncComponent(() => import('./FormSection'));
const FormSectionExpandCollapse = defineAsyncComponent(() => import('./FormSectionExpandCollapse'));
const FormSeparator = defineAsyncComponent(() => import('./FormSeparator'));
const ImpressionsAdspendChart = defineAsyncComponent(() => import('./ImpressionsAdspendChart'));
const InventoryMap = defineAsyncComponent(() => import('./InventoryMap'));
const InventoryMapBaidu = defineAsyncComponent(() => import('./InventoryMapBaidu'));
const LoaderSmall = defineAsyncComponent(() => import('./LoaderSmall'));
const LocationTreeNode = defineAsyncComponent(() => import('./locationSelector/LocationTreeNode'));
const Modal = defineAsyncComponent(() => import('./Modal'));
const MoreTargetingSelector = defineAsyncComponent(() => import('./MoreTargetingSelector'));
const PollenTargetingDetails = defineAsyncComponent(() => import('./targeting/pollen/PollenTargetingDetails'));
const PollenTargetingEditor = defineAsyncComponent(() => import('./targeting/pollen/PollenTargetingEditor'));
const RecommendedCreativeSizes = defineAsyncComponent(() => import('./RecommendedCreativeSizes'));
const SaveAndCancel = defineAsyncComponent(() => import('./SaveAndCancel'));
const SelectableExpandableSmallTiles = defineAsyncComponent(() => import('./SelectableExpandableSmallTiles'));
const SelectableTiles = defineAsyncComponent(() => import('./SelectableTiles'));
const SelectedLocationsTree = defineAsyncComponent(() => import('./SelectedLocationsTree'));
const SingleChart = defineAsyncComponent(() => import('./SingleChart'));
const SliderChart = defineAsyncComponent(() => import('./SliderChart'));
const SteppedSlider = defineAsyncComponent(() => import('./SteppedSlider'));
const Tabs = defineAsyncComponent(() => import('./Tabs'));
const TabsSlider = defineAsyncComponent(() => import('./TabsSlider'));
const Table = defineAsyncComponent(() => import('./table/Table'));
const ToggleButton = defineAsyncComponent(() => import('./ToggleButton'));
const UnitDimension = defineAsyncComponent(() => import('./UnitDimension'));
const UnitDimensions = defineAsyncComponent(() => import('./UnitDimensions'));
const UnitRatioStatuses = defineAsyncComponent(() => import('./UnitRatioStatuses'));
const WeatherTargetingDetails = defineAsyncComponent(() => import('./targeting/weather/WeatherTargetingDetails'));
const WeatherTargetingEditor = defineAsyncComponent(() => import('./targeting/weather/WeatherTargetingEditor'));

export {
  Border,
  ConfirmLosingChangesModal,
  DatePicker,
  DateRangePicker,
  DaypartEditor,
  DaypartViewer,
  DemographicSelector,
  DropDown,
  DropDownGroup,
  DropDownSelectableOptionGroup,
  EditableInput,
  EntityActions,
  FormattedInput,
  FormLabel,
  FormSection,
  FormSectionExpandCollapse,
  FormSeparator,
  ImpressionsAdspendChart,
  InventoryMap,
  InventoryMapBaidu,
  LoaderSmall,
  LocationTreeNode,
  Modal,
  MoreTargetingSelector,
  PollenTargetingDetails,
  PollenTargetingEditor,
  RecommendedCreativeSizes,
  SaveAndCancel,
  SelectableExpandableSmallTiles,
  SelectableTiles,
  SelectedLocationsTree,
  SingleChart,
  SliderChart,
  SteppedSlider,
  Table,
  Tabs,
  TabsSlider,
  ToggleButton,
  UnitDimension,
  UnitDimensions,
  UnitRatioStatuses,
  WeatherTargetingDetails,
  WeatherTargetingEditor,
};

export default {};
